import { render } from "./AdminTopbar.vue?vue&type=template&id=bc7b8dfc"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=bc7b8dfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__